import React from "react";
import { AiFillGithub } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";
import { BiMailSend } from "react-icons/bi";
import layer1 from "../../../assets/layer1.svg";

const Intro = () => {
  return (
    <div className="intro">
      <div className="avatar">
        <img src="https://github.com/hmseeb.png" alt="Haseeb Azhar" />
        <a
          rel="noreferrer"
          href="https://github.com/hmseeb"
          target="_blank"
          className="orb-icon"
        >
          <AiFillGithub />
        </a>
        <a
          rel="noreferrer"
          href="https://www.linkedin.com/in/hmseeb/"
          target="_blank"
          className="orb-icon"
        >
          <AiFillLinkedin />
        </a>
        <a
          rel="noreferrer"
          href="mailto:haseeb@legistech.dev"
          target="_blank"
          className="orb-icon"
        >
          <BiMailSend />
        </a>
      </div>
      <div
        className="intro-spacer"
        style={{ backgroundImage: `url(${layer1}` }}
      ></div>
    </div>
  );
};

export default Intro;
